import { render, staticRenderFns } from "./WineComponent.vue?vue&type=template&id=3efb4af9&scoped=true"
import script from "./WineComponent.vue?vue&type=script&lang=js"
export * from "./WineComponent.vue?vue&type=script&lang=js"
import style0 from "./WineComponent.vue?vue&type=style&index=0&id=3efb4af9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efb4af9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3efb4af9')) {
      api.createRecord('3efb4af9', component.options)
    } else {
      api.reload('3efb4af9', component.options)
    }
    module.hot.accept("./WineComponent.vue?vue&type=template&id=3efb4af9&scoped=true", function () {
      api.rerender('3efb4af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/WineComponent.vue"
export default component.exports